// Scope: asks the current guest to accept or decline a server-issued chat request.

import React from "react";

const Confirmation = ({ host, socket, guest, handleAnswer, queuedCount = 0 }) => {
    const handleConfirm = (response) => {
        handleAnswer(response);
        socket.emit("confirmationResponse", {
            guestResponse: response,
            chatParty: { host, guest },
        });

    };

    return (
        <div className="confirmation-overlay">
            <div
                className="confirmation-box"
                role="dialog"
                aria-modal="true"
                aria-labelledby="chat-request-title"
            >
                <div className="confirmation-box__identity" aria-hidden="true">
                    {host.name?.slice(0, 1).toUpperCase()}
                </div>
                <p className="confirmation-box__eyebrow">Incoming chat request</p>
                <h3 id="chat-request-title">{host.name} wants to chat</h3>
                <p className="confirmation-box__copy">
                    Accept to open a private, temporary conversation. Messages disappear when the server restarts.
                </p>
                {queuedCount > 0 && <p className="confirmation-box__queue">{queuedCount} more request{queuedCount === 1 ? "" : "s"} waiting</p>}
                <div className="confirmation-buttons">
                    <button className="confirmation-decline" onClick={() => handleConfirm("no")}>Not now</button>
                    <button className="confirmation-accept" autoFocus onClick={() => handleConfirm("yes")}>Accept request</button>
                </div>
            </div>
        </div>
    );
};

export default Confirmation;
